/**
 * @desc 列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LabelInfoResponseDto>>;
export function request(
  body: defs.basics.LabelInfoRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/core/labelInfo/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
